





















































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import GoodSelect from "@/components/goods-select/index.vue";
import { ImageDrop } from "quill-image-drop-module";
import PicModal from "@/components/upload/picModal.vue";
import SelectUrl from "@/components/selectUrl/index.vue";
@Component({
  components: {
    GoodSelect,
    PicModal,
    SelectUrl,
  },
})
export default class IntervalSwiper extends Vue {
  @Prop({
    type: Boolean,
    default: () => false,
  })
  showDemo!: boolean;

  @Prop({
    type: Object,
    default: () => {
      return {
        type: "intervalPictures",
        bg: null,
        items: [
          {
            items: [
              {
                imgUrl: [
                  {
                    img: null,
                    url: null,
                  },
                ],
                selectIndex: 0,
                styleType: 0,
              },
            ],
            title: null,
          },
        ],
      };
    },
  })
  PicturesConfig!: any;

  pictureList: any = {
    items: [],
  };
  styleList = [
    { img: require("@/assets/images/picture-1.jpg"), title: "1张图", num: 1 },
    { img: require("@/assets/images/picture-2.jpg"), title: "2张图", num: 2 },
    { img: require("@/assets/images/picture-3.jpg"), title: "3张图", num: 3 },
    { img: require("@/assets/images/picture-4.jpg"), title: "4张图", num: 4 },
    { img: require("@/assets/images/picture-5.jpg"), title: "2张平分", num: 2 },
    { img: require("@/assets/images/picture-6.jpg"), title: "3张平分", num: 3 },
    {
      img: require("@/assets/images/picture-7.png"),
      title: "4张左右平分",
      num: 4,
    },
    {
      img: require("@/assets/images/picture-8.jpg"),
      title: "4张上下平分",
      num: 4,
    },
  ];

  @Watch("PicturesConfig", { immediate: true, deep: true })
  getPictureList() {
    this.pictureList = this.PicturesConfig.items.filter(
      (item) => item.checked
    )[0];
  }

  mounted() {}

  titleColorChange(e, index) {
    this.PicturesConfig.items[index].color = e;
  }

  /**
   * 样式更改
   */
  styleChange(parent, child, row, index) {
    this.PicturesConfig.items[parent].items[child].styleType = index;
    if (
      this.PicturesConfig.items[parent].items[child].imgUrl.length < row.num
    ) {
      let len =
        row.num - this.PicturesConfig.items[parent].items[child].imgUrl.length;
      for (let i = 0; i < len; i++) {
        let obj = {
          img: null,
          url: null,
        };
        this.PicturesConfig.items[parent].items[child].imgUrl.push(obj);
      }
    } else if (
      this.PicturesConfig.items[parent].items[child].imgUrl.length > row.num
    ) {
      let len =
        this.PicturesConfig.items[parent].items[child].imgUrl.length - row.num;
      this.PicturesConfig.items[parent].items[child].imgUrl.splice(
        row.num,
        len
      );
    }
    this.PicturesConfig.items[parent].items[child].selectIndex = 0;
  }

  /**
   * 选择虚线框
   */
  selectChange(parent, child, index) {
    this.$set(
      this.PicturesConfig.items[parent].items[child],
      "selectIndex",
      index
    );
  }

  // 选择右边组件
  selectRight(index) {
    this.$emit("handleSelectrightPic", index);
  }
  /**
   * 删除模块
   */
  deleteFn(index) {
    this.PicturesConfig.items.splice(index, 1);
    this.selectRight(0);
  }
  deleteCarouselFn(index, subIndex) {
    this.PicturesConfig.items[index].items.splice(subIndex, 1);
    this.PicturesConfig.items[index].selectIndex = 0;
  }
  /**
   * 添加模块
   */
  addFn(index) {
    let obj = {
      items: [
        {
          imgUrl: [
            {
              img: null,
              url: null,
            },
          ],
          selectIndex: 0,
          styleType: 0,
        },
      ],
      selectIndex: 0,
      checked: true,
      title: null,
      color: "#000",
    };
    this.PicturesConfig.items.push(obj);
  }
  addCarouselFn(index, subIndex) {
    let obj = {
      selectIndex: 0,
      styleType: 0,
      imgUrl: [
        {
          img: null,
          url: null,
        },
      ],
    };
    this.PicturesConfig.items[index].items.push(obj);
  }
  getNewArray(array, subGroupLength) {
    let index = 0;
    let newArray = [];
    while (index < array.length) {
      newArray.push(array.slice(index, (index += subGroupLength)));
    }
    return newArray;
  }
  /**
   * 选择图片
   */
  picChange(e, index, subIndex) {
    let target = this.PicturesConfig.items[index].items[subIndex];
    target.imgUrl[target.selectIndex]["img"] = e[0].url;
  }

  bgPicChange(e) {
    this.PicturesConfig.bg = e[0].url;
  }

  urlChange(e, index, subIndex) {
    let target = this.PicturesConfig.items[index].items[subIndex];
    target.imgUrl[target.selectIndex]["url"] = e;
  }
}
